var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDebounce, useError, useLoader, useOrganizations } from "@piiqtechnologies/ui-lib";
import { PeekAutocomplete, PeekInput } from "@piiqtechnologies/ui-components";
export const OrganizationSearchSelector = (_a) => {
    var { form, field } = _a, props = __rest(_a, ["form", "field"]);
    const { setError } = useError();
    const { setLoader } = useLoader();
    const [searchKey, setSearchKey] = useState("");
    const debouncedSearchKey = useDebounce(searchKey, 700);
    const firstLoad = useRef(false);
    const [getOrganizations, userOrganizations, organizationsLoading, organizationsError] = useOrganizations();
    useEffect(() => {
        setLoader(organizationsLoading, "organizationsLoading");
        return () => setLoader(false, "organizationsLoading");
    }, [organizationsLoading]);
    useEffect(() => {
        if (organizationsError) {
            setError(organizationsError === null || organizationsError === void 0 ? void 0 : organizationsError.message);
        }
    }, [organizationsError]);
    useEffect(() => {
        getOrganizations({
            search: debouncedSearchKey || undefined,
        });
    }, [debouncedSearchKey]);
    const OrganizationOptions = useMemo(() => {
        var _a;
        if (!(userOrganizations === null || userOrganizations === void 0 ? void 0 : userOrganizations.data))
            return [];
        return (_a = userOrganizations.data) === null || _a === void 0 ? void 0 : _a.filter((org) => !searchKey || org.name.match(new RegExp(searchKey, "i"))).map(({ _id, name }) => ({ _id, name }));
    }, [userOrganizations === null || userOrganizations === void 0 ? void 0 : userOrganizations.data, searchKey]);
    useEffect(() => {
        var _a;
        if (!firstLoad.current && ((_a = userOrganizations === null || userOrganizations === void 0 ? void 0 : userOrganizations.data) === null || _a === void 0 ? void 0 : _a.length)) {
            firstLoad.current = true;
            const preSelectedOrganization = userOrganizations.data.find((organization) => { var _a; return (organization === null || organization === void 0 ? void 0 : organization._id) === ((_a = field.value) === null || _a === void 0 ? void 0 : _a._id); });
            if (preSelectedOrganization) {
                //@ts-ignore
                form.setFieldValue(field.name, { _id: preSelectedOrganization === null || preSelectedOrganization === void 0 ? void 0 : preSelectedOrganization._id });
            }
        }
    }, [userOrganizations === null || userOrganizations === void 0 ? void 0 : userOrganizations.data]);
    const handleOrganizationSelection = (_event, organization) => {
        //@ts-ignore
        form.setFieldValue(field.name, { _id: organization === null || organization === void 0 ? void 0 : organization._id });
    };
    if (!OrganizationOptions.length && !firstLoad.current)
        return null;
    return (React.createElement(PeekAutocomplete, { freeSolo: false, clearIcon: null, popupIcon: null, onChange: handleOrganizationSelection, options: OrganizationOptions || [], getOptionLabel: (value) => value === null || value === void 0 ? void 0 : value.name, sx: { ".MuiAutocomplete-input": { pl: "4px !important" } }, value: OrganizationOptions.find((option) => { var _a; return (option === null || option === void 0 ? void 0 : option._id) === ((_a = field.value) === null || _a === void 0 ? void 0 : _a._id); }), isOptionEqualToValue: (option, value) => (option === null || option === void 0 ? void 0 : option._id) === (value === null || value === void 0 ? void 0 : value._id), renderInput: (params) => {
            return (React.createElement(PeekInput, Object.assign({ field: Object.assign(Object.assign({}, field), { value: searchKey, onChange: (e) => setSearchKey(e.target.value) }), form: form }, params, props, { InputLabelProps: { required: true }, InputProps: Object.assign({}, params.InputProps) })));
        } }));
};
export default OrganizationSearchSelector;
